import { ICol } from "src/interfaces";

interface Props {
  col: ICol;
  children: React.ReactNode;
  uppercase: boolean | undefined;
}
const GuernseySummaryWrapper = ({ col, children, uppercase }: Props) => {
  return (
    <div
      style={{
        textTransform: uppercase ? "uppercase" : "none",
        color: col.changed
          ? col.changedType === "edit"
            ? "red"
            : "green"
          : "auto",
      }}>
      {children}
    </div>
  );
};
export default GuernseySummaryWrapper;
